import { call, put } from "redux-saga/effects";
import apiChat from "../../services/apiChat";

import AuthActions from "../ducks/auth";
import UsersActions from "../ducks/users";

export function* signIn({ email, password }) {
  try {
    const response = yield call(apiChat.post, "login", { email, password });

    localStorage.setItem("@chat-app:token", `Bearer ${response.data.token}`);

    yield put(
      AuthActions.signInSuccess(response.data.token, response.data.user)
    );

    yield put(
      UsersActions.getUsers(
        response.data.user.customer.key,
        response.data.user._id,
        response.data.user.admin
      )
    );
  } catch (err) {
    // TODO
  }
}

export function* getUser() {
  try {
    const response = yield call(apiChat.get, "current");

    yield put(AuthActions.getUserSuccess(response.data));
    yield put(
      UsersActions.getUsers(
        response.data.customer.key,
        response.data._id,
        response.data.admin
      )
    );
  } catch (err) {
    // TODO
    yield localStorage.removeItem("@chat-app:token");
  }
}



// WEBPACK FOOTER //
// ./src/storeChat/sagas/auth.js